module.exports = __webpack_public_path__ + "static/background-footer-ff940758465779eb953a9fce66eaa50b.png";